import { createSelector } from 'reselect';

import { RootState } from '../reducers';
import { SubscriptionInfo, SubscriptionItem, ProductSubscriptions } from './subscription.types';
import { getMixersList } from '../entities/mixers/mixers.selector';

export const getSubscriptions = (state: RootState) => state.subscription.subscriptions;
export const getCLDevices = (state: RootState) => state.subscription.cloudLynkDevices;

export const getUnusedCLSerialNumbers = createSelector(
  [getCLDevices, getMixersList],
  (devices, mixers) => (selectedMixerId?: string) => {
    const usedSerialNumbers = mixers.filter((mixer) => mixer.id !== selectedMixerId).map((mixer) => mixer.serialNumber);
    return devices.filter((device) => !usedSerialNumbers.includes(device.serialNumber));
  },
);

export const getAllSubscriptionItems = createSelector(getSubscriptions, (subscriptions: SubscriptionInfo[]) =>
  subscriptions.reduce((acc, elem) => [...acc, ...elem.node.items], []),
);

export const hasFarmerSubscription = createSelector(getAllSubscriptionItems, (items: SubscriptionItem[]) =>
  items.length === 0
    ? null
    : items.some((elem) => elem.productName.toLowerCase().includes(ProductSubscriptions.FEED_FARMER.toLowerCase())),
);

export const hasLiteSubscription = createSelector(getAllSubscriptionItems, (items: SubscriptionItem[]) =>
  items.length === 0
    ? null
    : items.some((elem) => elem.productName.toLowerCase().includes(ProductSubscriptions.FEED_LITE.toLowerCase())),
);

export const hasProSubscription = createSelector(getAllSubscriptionItems, (items: SubscriptionItem[]) =>
  items.length === 0
    ? null
    : items.some((elem) => elem.productName.toLowerCase().includes(ProductSubscriptions.FEED_PRO.toLowerCase())),
);

export const hasFeedlotSubscription = createSelector(getAllSubscriptionItems, (items: SubscriptionItem[]) =>
  items.length === 0
    ? null
    : items.some((elem) => elem.productName.toLowerCase().includes(ProductSubscriptions.FEED_FEEDLOT.toLowerCase())),
);
